export default "__VITE_ASSET__008e2d3a__"